import { StyleSheet, Platform } from 'react-native'

export const styles = StyleSheet.create({
  dispute: {
    // maxWidth: '100%',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    width: '100%',
    marginVertical: 10,
  },
  paragraph: {
    marginBottom: 10,
  },
  img: {
    aspectRatio: 1000/720,
  },
  button: {
    marginTop:10,
  },
});

export default styles;